import { Drawer, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { EditDeliveryAddressDrawerContent } from './EditDeliveryAddressDrawerContent';
import { TrackEditDeliveryAddressAnalytics } from '../../../utils/edit-delivery-address/analytics';
import { EditDeliveryAddressProvider } from '../../../contexts/EditDeliveryAddressContext';
export var EditDeliveryAddress = function () {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(false), isOuterClick = _b[0], setIsOuterClick = _b[1];
    useEffect(function () {
        TrackEditDeliveryAddressAnalytics('purchase history: order details: edit delivery address displayed', 'button submission');
    }, []);
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(Link, { component: "button", variant: "body-base", onClick: function () {
                setOpen(true);
                TrackEditDeliveryAddressAnalytics('edit delivery address overlay', 'overlay');
            } }, "Edit"),
        open && (React.createElement(Drawer, { open: open, onClose: function () {
                setIsOuterClick(true);
            } },
            React.createElement(EditDeliveryAddressProvider, null,
                React.createElement(EditDeliveryAddressDrawerContent, { setOpen: setOpen, isOuterClick: isOuterClick, setIsOuterClick: setIsOuterClick }))))));
};
